import React from "react";
import { Line } from "react-chartjs-2";

export default function DisplayCommentsChart({ comsChart }) {
    const isEmpty = !comsChart || Object.keys(comsChart).length === 0;

    if (isEmpty) {
        return (
            <div class="loading-container">
                <span class="loading-text">Loading data</span>
                <span class="loading-dots">
                    <span></span><span></span><span></span>
                </span>
            </div>
        );
    }
    // No comments in the last week
    //This just loads forever. Need to fix the initial entry data to include "Loading" instead.
    if (Object.keys(comsChart).length === 0) {
        return (
            <div className="empty-state-container">
                <p className="empty-state-title">No comments in the last week</p>
                <p className="empty-state-subtitle">
                    There has been no comment activity during this period.
                </p>
            </div>
        );
    }

    return (
            <Line
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    devicePixelRatio: window.devicePixelRatio,
                    elements: {
                        line: {
                            tension: 0.4
                        }
                    },
                    plugins: {
                        legend: { position: "top" },
                        title: { display: false },
                    },
                    interaction: { mode: "index", intersect: false },
                    scales: {
                        y: { beginAtZero: true, ticks:{precision:0}, title: { display: true, text: "Number of Comments" } },
                        x: { title: { display: true, text: "Date" } },
                    },
                }}
                data={comsChart}
            />
    );
}
